<template>
  <b-dropdown
    block
    no-caret
    variant="link"
    class="as-select"
    toggle-class="as-select__toggle"
    menu-class="as-select__menu"
    :title="title"
  >
    <template #button-content>
      <feather-icon
        :icon="icon"
        size="18"
        class="as-select__icon"
      />
      <span class="as-select__label">{{ selectedText }}</span>
      <feather-icon
        icon="ChevronDownIcon"
        size="16"
        class="as-select__chevron"
      />
    </template>

    <b-dropdown-item-button
      v-for="option in normalized"
      :key="String(option.value)"
      :active="option.value === value"
      @click="select(option.value)"
    >
      <span class="as-select__text">{{ option.text }}</span>
      <feather-icon
        v-if="option.value === value"
        icon="CheckIcon"
        size="16"
        class="as-select__check"
      />
    </b-dropdown-item-button>
  </b-dropdown>
</template>

<script>
export default {
  name: 'SessionSelect',
  model: { prop: 'value', event: 'input' },
  props: {
    value: { type: [String, Number], default: '' },
    options: { type: Array, default: () => [] },
    icon: { type: String, default: 'ListIcon' },
    title: { type: String, default: null },
  },
  computed: {
    normalized() {
      return this.options.map(o => (typeof o === 'object' ? o : { value: o, text: String(o) }))
    },
    selectedText() {
      const found = this.normalized.find(o => o.value === this.value)
      return found ? found.text : ''
    },
  },
  methods: {
    select(value) {
      if (value === this.value) return
      this.$emit('input', value)
      this.$emit('change', value)
    },
  },
}
</script>
